<div
  class="bg-color-white u-margin-16-0 u-padding-16"
  fxLayout="row"
  fxLayoutAlign="space-between"
>
  <div fxLayout="row">
    <mat-icon
      [ngClass]="imageColor ?? 'color-teal-700'"
      class="material-symbols-outlined"
      >{{ imageName }}</mat-icon
    >
    <div class="u-marginLeft-8">
      <p class="text-body-2">
        <b>{{ title }}</b>
      </p>
      <p [innerHTML]="description" class="text-body-2"></p>
    </div>
  </div>
  @if (buttonText) {
    <button (click)="action.emit()" color="primary" mat-stroked-button>
      <span>{{ buttonText }}</span>
    </button>
  }
</div>
